<template>
	<div>
		<Dialog
			title="更新内容"
			:hide="dialogVisible"
			@handleClick="changeClose"
		>
			<div slot="header">{{ form.softVersion }}更新内容</div>
			<div slot="body">
        <div class="ml20">{{formatDate(form.releaseTime)}}</div>
				<div class="p20 color111 f16" v-html="form.detailContent"></div>
			</div>
			<div slot="footer">
				<el-button type="primary" @click="save">确定</el-button>
			</div>
		</Dialog>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import Dialog from '../../../components/common/dialog.vue'
export default {
	data() {
		return {
			dialogVisible: false,
			form: {},
		}
	},
	mixins: [minxin],
	components: { Dialog },
	created() {
		this.init()
	},
	methods: {
		init() {
			this.$on('set', function(row) {
				//清空id和uid
				Object.assign(this.$data, this.$options.data())
				this.dialogVisible = true

				if (row) {
					this.initGet(row.id)
				}
			})
		},
		initGet(id) {
			this.$api
				.get(this.$url.versionManage.get, {
					id: id ? id : '',
				})
				.then((res) => {
					if (res) {
						this.form = res
					}
				})
				.catch((error) => {})
		},
		changeClose(show) {
			this.dialogVisible = show
			this.$emit('handleChange', true)
		},
		save() {
			this.dialogVisible = false
			this.$emit('handleChange', true)
		},
	},
}
</script>

<style>

</style>
